import moment from 'moment';

function controller($scope, Profile, $routeParams, users) {

  let frequency;

  $scope.endDate = moment().add(2, 'months').endOf('month').toDate();
  $scope.blockWeekends = true;
  $scope.setup = false;
  $scope.recurring = false;
  $scope.showDatePicker = false
  $scope.withdrawAll = false;
  $scope.selectedAccountType = null;

  let id;
  if ($routeParams.clientId && users.hasRole('staff')) {
    id = $routeParams.clientId;
  }
  Profile.get({ id }, profile => {
    $scope.country = profile.address.country || '';
    $scope.province = profile.address.province || '';
  });

  $scope.preselectedInvestmentAccountId = '';
  if ($routeParams.investmentAccountId) {
    $scope.preselectedInvestmentAccountId = parseInt($routeParams.investmentAccountId);
  }

  $scope.$watch('transfer.investmentAccountId', () => {
    conditionallyShowDatePicker()
    $scope.setSelectedAccount($scope.transfer.investmentAccountId, $scope.accounts);
  });

  $scope.$watch('transfer.frequency', () => {
    conditionallyShowDatePicker()
  });

  $scope.$watch('transfer', () => {
    if ($scope.setup) { return; }

    $scope.setup = true;
    ({ frequency } = $scope.transfer);
    if (frequency === 0) {
      return ($scope.recurring = false);
    } else if (frequency !== undefined && frequency !== null) {
      return ($scope.recurring = true);
    }
  });

  $scope.$watch('recurring', (newValue, oldValue) => {
    if (newValue && $scope.categories.isWithdrawal($scope.transfer)) {
      $scope.withdrawAll = false;
    }

    if (oldValue && !newValue) {
      delete $scope.transfer.frequency;
      delete $scope.transfer.transferAt;
    }
    $scope.transfer.amountValue = null;
  });

  $scope.$watch('withdrawAll', (newValue, oldValue) => {
    if (!$scope.categories.isWithdrawal($scope.transfer)) return void 0;

    if (newValue) {
      $scope.transfer.category = 'withdrawal_all';
      $scope.transfer.title = 'Withdraw All Funds?';
      $scope.transfer.amountValue = $scope.selectedAccountBalance;
    } else {
      $scope.transfer.category = 'withdrawal';
      $scope.transfer.title = 'Continue Withdrawal?';
      $scope.transfer.amountValue = null;
    }
  });

  $scope.setFrequencyOnce = () => {
    $scope.transfer.frequency = 0;
    delete $scope.transfer.transferAt;
  };

  $scope.setTransferDate = date => {
    $scope.transfer.transferAt = moment(date);
  };

  // we only want to show the datepicker if user has both selected the account they want,
  // and selected a frequency.  Otherwise we don't have the data to set the default/minimum date properly
  function conditionallyShowDatePicker() {
    if ($scope.transfer.frequency && $scope.selectedAccount){
      $scope.showDatePicker = true;
      setEarliestDate();
    } else {
      $scope.showDatePicker = false;
    }
  }

  $scope.isCanada = () => $scope.country && $scope.country.toLowerCase() === 'can';

  $scope.isQuebec = () => $scope.province && $scope.province.toLowerCase() === 'qc';

  $scope.isTransferDate = value => {
    if (value === undefined) { return false; }
    if ($scope.transfer.transferAt === null) { return false; }

    value = moment(value);
    return value.isSame($scope.transfer.transferAt);
  };

  $scope.setSelectedAccount = (id, accounts) => {
    if (!id) {
      $scope.selectedAccountType = undefined;
      $scope.selectedAccountBalance = undefined;
    }

    if (id && accounts) {
      const account = accounts.find(a => a.id === id);
      $scope.selectedAccount = account;
      $scope.selectedAccountCustodian = account.custodianAlias;
      $scope.selectedAccountType = account.accountType;
      $scope.selectedAccountTypeName = account.accountTypeName;
      $scope.selectedAccountBalance = account.balance || '0';
      if ($scope.withdrawAll) { $scope.transfer.amountValue = $scope.selectedAccountBalance; }
    }
  };

  $scope.isSelectedAccountType = (type, accountType) => {
    if (type && accountType) return type.toLowerCase() === accountType.toLowerCase();
  };

  $scope.isRrifVariant = () => ['rrif', 'spousal_rrif', 'lrif', 'lira'].includes($scope.selectedAccountType.toLowerCase());

  $scope.isTaxWithheld = () => {
    if (
      $scope.selectedAccountType
      && ['rrif', 'spousal_rrif', 'lrif', 'lira', 'rrsp'].includes($scope.selectedAccountType.toLowerCase())
      && $scope.transfer.amountValue >= $scope.config.withdrawalMinAmount
      && $scope.categories.isWithdrawal($scope.transfer)
      ) {
      return true
    }
  }

  // find how many business days from now until we can start a recurring transfer
  // All conditional logic about when this is called is handled in conditionallyShowDatePicker
  function setEarliestDate() {
    const workDays = () => {
      if ($scope.transfer.category === 'deposit') {
        return $scope.selectedAccount.custodianAlias === 'VB' ? 1 : 5;
        // VB transfers are submitted daily through transfers:submit_efts rake task, so they can be processed in a single day (1)
        // with other custodians we submit transfers through a more manual process, which can take more time, so we set the default to (5) days
      }
      // withdrawal
      return 10;
    };
    // set the earliest date on which a recurring transfer can be started
    $scope.transferEarliestDate = moment().addWorkdays(workDays()).startOf('day');

    // set the earlist date to be selected by default
    $scope.transfer.transferAt = $scope.transferEarliestDate;
  }

  $scope.isAccountRRSPLike = accountType =>
    accountType === 'rrsp' ||
    accountType === 'rrif' ||
    accountType === 'spousal_rrif' ||
    accountType === 'group_rrsp' ||
    accountType === 'spousal' ||
    accountType === 'gsrsp' ||
    accountType === 'lrif';

  $scope.isAccountNonRegistered = accountType =>
    accountType === 'basic' ||
    accountType === 'joint' ||
    accountType === 'corporate' ||
    accountType === 'trust' ||
    accountType === 'informal_trust';

  $scope.calcRrspTax = (value) => {
    if (!$scope.isCanada()) {
      return (value * 0.75).toFixed(2);
    }
    let afterTax;
    const isQuebec = $scope.isQuebec();

    if (value <= 5000) {
      afterTax = value * (isQuebec ? .80 : .90);
    } else if (value <= 15000) {
      afterTax = value * (isQuebec ? .75 : .80);
    } else {
      afterTax = value * (isQuebec ? .70 : .70);
    }

    return afterTax.toFixed(2);
  };

  $scope.filterDropdownMenuAccounts = (input) => {
    // filters out unpermitted account types from the "Select an account" dropdown in deposits and withdrawals
    if (input && input.accountType) {
      if ($scope.categories.isDeposit(this.transfer)) {
        return input.supportsDeposits;
      }
      if ($scope.categories.isWithdrawal(this.transfer)) {
        return input.supportsWithdrawals;
      }
    }
    return true;
  };

  return $scope;
}

export default [
  '$scope',
  'Profile',
  '$routeParams',
  'users',
  controller,
];
